module.exports = __webpack_public_path__ + "img/bin.77da34cb.svg";